export default __webpack_public_path__ + "static/feature-banner-honeymoon-f3f51f893e8c47a9253d83e26becc273.jpg";